/**
 * Helper: Check if fonts are loaded using FontFaceSet API
 * Waits for web fonts to be ready before resolving
 * @returns {Promise<void>}
 */
export const waitForFonts = () => {
    return new Promise((resolve) => {
        if (!document.fonts) {
            setTimeout(resolve, 150);
            return;
        }

        // Check if fonts are already loaded
        if (document.fonts.status === 'loaded') {
            resolve();
            return;
        }

        // Wait for fonts with timeout fallback
        const fontTimeout = setTimeout(() => {
            resolve();
        }, 3000);

        document.fonts.ready
            .then(() => {
                clearTimeout(fontTimeout);
                setTimeout(resolve, 100);
            })
            .catch(() => {
                clearTimeout(fontTimeout);
                resolve();
            });
    });
};
